module.exports = {"371725001":"郓州街道","371725002":"唐塔街道","371725101":"黄安镇","371725102":"杨庄集镇","371725103":"侯咽集镇","371725104":"武安镇","371725105":"郭屯镇","371725106":"丁里长镇","371725107":"玉皇庙镇","371725108":"程屯镇","371725109":"随官屯镇","371725110":"张营镇","371725111":"潘渡镇","371725112":"双桥镇","371725113":"南赵楼镇","371725114":"黄泥冈镇","371725115":"唐庙镇","371725116":"李集镇","371725117":"黄集镇","371725118":"张鲁集镇","371725208":"水堡乡","371725209":"陈坡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371725.json
// module id = 1507
// module chunks = 0